export default __webpack_public_path__ + "static/media/gear-bk.813e1b08.png";